import angular from 'angular'

// component
import timer from './component/timer.component.js'

export default angular
  .module('portalApp.timer', [])
  .component('timer', timer)
  .name
